import { useContext } from 'react';
import { createContextHook } from '@/utils';
import { PageExperienceContext } from './PageExperienceContext';

export const usePageExperienceContext = createContextHook(
  PageExperienceContext
);

// Non-throwing variant — returns undefined when used outside a provider.
// Use this in hooks/components that should work both inside and outside an
// experience page (e.g. AppHeader when rendered on the library page).
export const usePageExperienceContextOptional = () =>
  useContext(PageExperienceContext);
